import { postApiCall } from "../../utils/request";

export const startTest = (assignment_id) => async (dispatch) => {
  try {
    const response = await postApiCall(`language-tests/assignments/${assignment_id}/start`);
    if (response.status === 200 && response.data?.status === "success") {
      dispatch({ type: "START_TEST_SUCCESSFULLY", payload: response.data.data });

      return { success: true, payload: response.data.data };
    }

    dispatch({ type: "START_TEST_FAILED", message: "Failed to start test" });
    return { success: false };

  } catch (error) {
    if (
      error?.response?.status === 400 &&
      error?.response?.data?.detail === "Assignment already completed"
    ) {
      return { alreadyCompleted: true };
    }
    dispatch({ type: "START_TEST_FAILED", message: "Something went wrong" });
    return { success: false };
  }
};

export const uploadAudio = (formData) => async (dispatch) => {
  try {
    const response = await postApiCall("audio/upload-audio", formData);

    if (response.status === 200 && response.data.success) {
      dispatch({ type: "UPLOAD_AUDIO_SUCCESS", payload: response.data.data});
      return { success: true, payload: response.data.data };
    } else {
      dispatch({ type: "UPLOAD_AUDIO_FAILED", message: "Upload failed" });
      return { success: false };
    }
  } catch (err) {
    dispatch({ type: "UPLOAD_AUDIO_FAILED", message: "Something went wrong" });
    return { success: false };
  }
};